import React from 'react';

export const GetQuoteInfo = ({ title, description1, description2, minimal }) => (
    <div className="u-Space-down">
        <h2 className="Section-header">{title}</h2>
        <>
            <p>{description1}</p>
            <p>{description2}</p>
        </>
    </div>
);
